import { useCallback, useEffect, useState } from 'react';
import { useLlcApi } from '../Api';
import { TradingStatusDto } from '../types/trading';

interface TradingStatusState {
  status: TradingStatusDto | null;
  loading: boolean;
  error: boolean;
}

export function useTradingStatus(): TradingStatusState {
  const llcApi = useLlcApi();
  const [state, setState] = useState<TradingStatusState>({
    status: null,
    loading: true,
    error: false,
  });

  const load = useCallback(
    async (signal: AbortSignal) => {
      setState((s) => ({ ...s, loading: true, error: false }));
      try {
        const response = await llcApi.get<TradingStatusDto>(
          '/api/trading/status',
          { signal }
        );
        setState({ status: response.data, loading: false, error: false });
      } catch {
        if (signal.aborted) return;
        setState({ status: null, loading: false, error: true });
      }
    },
    [llcApi]
  );

  useEffect(() => {
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load]);

  return state;
}
